const adretailTranslate = {}

export default adretailTranslate
